import axios, { AxiosResponse } from "axios"
import { IOrgData } from "entities/api/_models"

const API_URL = process.env.REACT_APP_API_URL
const ORG_DATA_URL = (orgId: string) => `${API_URL}/orders/org-data?orgId=${orgId}`

export const getOrgData = (orgId: string): Promise<IOrgData> => {
  
  return axios
    .post(ORG_DATA_URL(orgId)) 
    .then((d: AxiosResponse<IOrgData>) => d.data) 
}